import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/country/indonesia/images/bodySectionBg.png";
import heroBg from "../../images/v4/country/indonesia/images/heroBg.png";

import indonesia from "../../images/v4/country/indonesia/icons/indonesia.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/country/malaysia/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/indonesia/images/countryBackground.png";
import benefitImg from "../../images/v4/country/indonesia/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/indonesia/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/indonesia/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/indonesia/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/indonesia/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${heroBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(93deg, #F00 0.73%, #FF9500 100.97%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "85%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(180deg, #009A99 0%, #1C297E 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    //paddingTop: "60px",
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "60%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#FFF8F5",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "90%",
    minWidth: "max-content",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      minWidth: "100%",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "25%",
    minWidth: "max-content",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(270deg, #00B181 -3.46%, #1448C4 100%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${heroBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const Indonesia = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question:
        "Which CRM solution is ideal for small businesses in Indonesia?",
      answer: (
        <>
          Pepper Cloud CRM is specifically designed for Indonesian small
          businesses, offering a blend of automation, scalability, and local
          support to help manage customer relationships and streamline
          operations.
        </>
      ),
    },
    {
      question: "How can my Indonesian business start using a CRM system?",
      answer: (
        <>
          Starting with Pepper Cloud CRM is easy and efficient. Whether you're a
          new business or expanding, Pepper Cloud helps you manage leads,
          pipelines, and customer engagement effortlessly.
          <ul>
            <li>
              Schedule a free demo to see the platform’s capabilities in action.
            </li>
            <li>
              Consult with local CRM specialists to find the best pricing plan
              for your needs.
            </li>
            <li>
              Get started quickly with a simple setup and no hidden costs.
            </li>
            <li>
              Customise your workflows to align with Indonesian market needs and
              sales processes.
            </li>
            <li>
              Launch seamlessly and leverage AI-powered features for business
              growth.
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "What factors should Indonesian businesses consider when selecting a CRM?",
      answer: (
        <>
          <ul>
            <li>
              Growth potential: Choose a CRM that scales with your expanding
              business and team.
            </li>
            <li>
              Customisation options: Ensure it supports Indonesia-specific sales
              workflows and practices.
            </li>
            <li>
              Tool integrations: Look for compatibility with tools like
              WhatsApp, email, and Google Workspace.
            </li>
            <li>
              Local support: Ensure the CRM provider offers dedicated guidance
              for the Indonesian market.
            </li>
            <li>
              Transparent pricing: Find a solution that offers great value
              without unexpected costs.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for startups in Indonesia?",
      answer: (
        <>
          Yes, Pepper Cloud CRM is an excellent choice for Indonesian startups.
          It’s affordable, simple to implement, and offers automated tools to
          help small teams manage leads and scale their business efficiently.
        </>
      ),
    },
    {
      question: "Does Pepper Cloud CRM integrate with other business tools?",
      answer: (
        <>
          Yes, Pepper Cloud CRM integrates seamlessly with essential business
          tools like Google Workspace, email services, and marketing platforms,
          creating a connected ecosystem that enhances operational efficiency.
        </>
      ),
    },
    {
      question:
        "How does Pepper Cloud CRM protect data for businesses in Indonesia?",
      answer: (
        <>
          Pepper Cloud CRM utilises robust encryption and security measures to
          ensure the safety of your data. It also helps businesses comply with
          local data protection laws, ensuring the security and privacy of your
          client information.
        </>
      ),
    },
    {
      question: "What are the most popular CRM solutions in Indonesia?",
      answer: (
        <>
          While several global CRM platforms are available, Pepper Cloud CRM is
          quickly gaining traction in Indonesia due to its WhatsApp integration,
          AI-powered features, and responsive local support.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM an affordable option for Indonesian SMES?",
      answer: (
        <>
          Yes, Pepper Cloud CRM offers flexible pricing that suits businesses at
          every stage, ensuring that small and medium-sized enterprises can
          access the features they need without exceeding their budgets.
        </>
      ),
    },
    {
      question:
        "What qualities should the best CRM for small businesses in Indonesia have?",
      answer: (
        <>
          The ideal CRM should be user-friendly, affordable, and tailored for
          the Indonesian market. Pepper Cloud CRM provides these qualities,
          offering easy navigation, automation, and essential communication
          tools to improve sales and customer loyalty.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Microsoft Dynamics 365",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud is purpose-built for Indonesian businesses, combining lead management, AI automation, and WhatsApp CRM into one unified platform. It supports startups, SMES, and enterprises with scalable features, making it the best CRM software in Indonesia for modern B2B teams.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI automation suite",
          desc: "Automate workflows, lead scoring, and deal progression with AI-driven assistance for enhanced efficiency.",
        },
        {
          title: "Omnichannel CRM",
          desc: "Centralise communication across email, WhatsApp, Facebook, and more for seamless customer engagement.",
        },
        {
          title: "Sales tracking tools",
          desc: "Visualise your pipeline stages, monitor deal progress, and forecast revenue with real-time dashboards.",
        },
        {
          title: "Seamless integrations",
          desc: "Easily connect with Google Workspace and essential business apps for a unified workflow.",
        },
        {
          title: "Indonesia-ready",
          desc: "Custom-built to meet Indonesia’s unique market needs, language preferences, and business workflows.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM offers a free plan and user-friendly interface, making it attractive for Indonesian companies starting out with CRM software. It’s ideal for those focused on lead nurturing and basic marketing automation.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "Free forever plan",
          desc: "Perfect for small teams and startups",
        },
        {
          title: "Pipeline management",
          desc: "Drag-and-drop visual tools",
        },
        {
          title: "Marketing features",
          desc: "Schedule emails and automate campaigns",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a global CRM system in Indonesia that caters to larger enterprises with complex workflows. It provides advanced customisation, analytics, and AI for high-scale operations and performance tracking.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Einstein AI",
          desc: "Predictive insights and smart lead scoring",
        },
        {
          title: "Custom CRM workflows",
          desc: "Flexible structure for large teams",
        },
        {
          title: "App ecosystem",
          desc: "Thousands of compatible add-ons",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM is a cost-effective and flexible solution for Indonesian SMES. Its modular design and AI assistant help sales teams manage pipelines and automate tasks with ease, making it one of the best CRM Indonesia options for growing businesses.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Task reminders and smart alerts",
        },
        {
          title: "Sales gamification",
          desc: "Incentivise team performance",
        },
        {
          title: "Custom modules",
          desc: "Adapt to your workflow and industry",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics integrates well with Office 365, making it an attractive CRM system that Indonesian enterprises use for seamless collaboration and analytics. It’s best suited for teams that rely heavily on Microsoft tools.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "AI insights",
          desc: "Advanced data tracking and suggestions",
        },
        {
          title: "Power BI integration",
          desc: "Visual reports and dashboards",
        },
        {
          title: "LinkedIn sync",
          desc: "Boost B2B lead engagement",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "Lead management system",
      desc: "Streamline lead capture from multiple channels, assign leads to teams, and track progress in real time to maximise conversion opportunities.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "AI-powered automation",
      desc: "Automate sales tasks and follow-ups with AI to boost efficiency, close deals faster, and let your team focus on strategic activities.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Customisable sales pipelines",
      desc: "Use AI to automate sales tasks and follow-ups, boost efficiency, close deals faster, and free your team to focus on high-impact activities.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "WhatsApp CRM integration",
      desc: "Automate messages, engage leads, and track interactions with WhatsApp CRM—reach customers on Indonesia’s top messaging platform seamlessly.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "Omnichannel communication hub",
      desc: "Centralise chats from email, WhatsApp & social media into one CRM for smooth, cohesive communication and a unified sales experience.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Mobile CRM access",
      desc: "Access real-time customer data and update sales on the go—empowering your team to stay responsive, efficient, and mobile-ready anytime.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Custom workflow builder",
      desc: "Create custom workflows for lead nurturing and deal tracking—cutting manual tasks, boosting speed, and enhancing team productivity and accuracy.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Activity tracking tool",
      desc: "Track calls, meetings, tasks, and follow-ups to drive timely actions, boost accountability, and ensure consistent sales communication.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "Seamless tool integrations",
      desc: "Integrate easily with Google Workspace, email tools & more to streamline operations and create a unified, efficient business ecosystem.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "AI-powered lead handling",
          content: "Automate property enquiries and schedule viewings with AI.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Smart client nurturing",
          content: "Send tailored property alerts and updates via WhatsApp.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Performance insights",
          content:
            "Track deal progress, team output, and buyer intent with analytics.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg1,
      alt: "Real Estate CRM for Indonesia",
      subtitle:
        "Real estate and property firms in Indonesia can streamline sales cycles and boost deal closures using AI-enhanced CRM tools for lead management, segmentation, and performance tracking.",
    },
    {
      tabContent: [
        {
          heading: "AI-driven appointment scheduling",
          content:
            "Automate confirmations, reschedules, and reminders across channels.",
          alt: "Healthcare CRM",
        },
        {
          heading: "24/7 patient support",
          content:
            "Use AI chatbots to respond instantly to patient queries and updates.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Centralised health records",
          content:
            "Track patient communication, history, and feedback in one CRM.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Healthcare CRM for Indonesia",
      subtitle:
        "Hospitals and clinics in Indonesia can improve patient experience and operational efficiency with an AI-powered CRM designed to centralise and automate critical communications.",
    },
    {
      tabContent: [
        {
          heading: "Client onboarding automation",
          content: "Speed up account setup with data verification workflows.",
          alt: "Financial Services CRM",
        },
        {
          heading: "Regulation compliance",
          content:
            "Ensure audit-readiness with automated record-keeping and tracking.",
          alt: "Financial Services CRM",
        },
        {
          heading: "Advisory personalisation",
          content:
            "Recommend services based on detailed client profiles and interactions.",
          alt: "Financial Services CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Financial Services CRM for Indonesia",
      subtitle:
        "Finance professionals in Indonesia can automate compliance, enhance advisory support, and centralise client records with secure AI-powered CRM tools.",
    },
    {
      tabContent: [
        {
          heading: "Unified customer view",
          content:
            "Sync data from e-commerce, social channels, and offline sales.",
          alt: "Retail and E-commerce CRM",
        },
        {
          heading: "Targeted campaign delivery",
          content:
            "Personalise flash sales and discounts based on shopping history.",
          alt: "Retail and E-commerce CRM",
        },
        {
          heading: "Multichannel support",
          content:
            "Deliver fast, consistent service via WhatsApp, Instagram, and email.",
          alt: "Retail and E-commerce CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Retail and E-commerce CRM for Indonesia",
      subtitle:
        "Retailers in Indonesia can increase conversions and loyalty by integrating AI CRM tools that centralise customer data and drive engagement across multiple platforms.",
    },
  ];
  const cards = [
    {
      heading: "What is CRM software for Indonesian businesses?",
      content:
        "CRM solutions streamline customer relationship management, boosting sales efficiency, improving marketing strategies, and enhancing customer experience. Businesses in Indonesia leverage CRM to stay competitive and build stronger client connections.",
    },
    {
      heading: "Why do businesses in Indonesia need a CRM?",
      content:
        "CRM software enhances business processes by organising customer data, automating workflows, and providing insights that lead to better decision-making, resulting in increased efficiency and customer satisfaction for Indonesian businesses.",
    },
  ];
  const adaptList = [
    {
      pointer: "Complete CRM solution",
      desc: "All-in-one platform for managing leads, automating sales tasks, and tracking customer interactions with no need for additional tools.",
      img: bestIcon1,
    },
    {
      pointer: "Scalable to fit your business",
      desc: "Suitable for businesses of all sizes, from startups to large enterprises, with a flexible structure that evolves with your needs.",
      img: bestIcon2,
    },
    {
      pointer: "Cost-effective pricing",
      desc: "Transparent, affordable pricing designed to provide maximum value without compromising on features or support.",
      img: bestIcon3,
    },
    {
      pointer: "Local support 24/7",
      desc: "Access dedicated, expert support from our team who understands the nuances of the Indonesian market.",
      img: bestIcon4,
    },
    {
      pointer: "Fully customisable",
      desc: "Tailor workflows, fields, and stages to match your unique sales process and business needs in Indonesia.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Centralise customer data to drive more efficient sales processes and faster conversions.",
    "Automate sales tasks to reduce manual work and increase deal-closing efficiency.",
    "Gain actionable insights with real-time analytics to make data-driven sales decisions.",
    "Improve collaboration across teams by unifying customer communication in one platform.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM Software in Indonesia | Pepper Cloud"}
        pathname={
          "https://peppercloud.com/country/best-crm-software-in-indonesia/"
        }
        keywords="crm software Indonesia, crm system in Indonesia, crm system Indonesia, best crm Indonesia"
        description={
          "Looking for the best CRM software in Indonesia? Try Pepper Cloud CRM—AI-powered, user-friendly, & perfect for SMEs. Boost sales & manage leads better today."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Which CRM solution is ideal for small businesses in Indonesia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is specifically designed for Indonesian small businesses, offering a blend of automation, scalability, and local support to help manage customer relationships and streamline operations.",
                },
              },
              {
                "@type": "Question",
                name: "How can my Indonesian business start using a CRM system?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Starting with Pepper Cloud CRM is easy and efficient. Whether you're a new business or expanding, Pepper Cloud helps you manage leads, pipelines, and customer engagement effortlessly.",
                },
              },
              {
                "@type": "Question",
                name: "What factors should Indonesian businesses consider when selecting a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "a. Growth potential: Choose a CRM that scales with your expanding business and team. b. Customisation options: Ensure it supports Indonesia-specific sales workflows and practices. c. Tool integrations: Look for compatibility with tools like WhatsApp, email, and Google Workspace. d. Local support: Ensure the CRM provider offers dedicated guidance for the Indonesian market. e. Transparent pricing: Find a solution that offers great value without unexpected costs.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for startups in Indonesia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM is an excellent choice for Indonesian startups. It’s affordable, simple to implement, and offers automated tools to help small teams manage leads and scale their business efficiently.",
                },
              },
              {
                "@type": "Question",
                name: "Does Pepper Cloud CRM integrate with other business tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM integrates seamlessly with essential business tools like Google Workspace, email services, and marketing platforms, creating a connected ecosystem that enhances operational efficiency.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud CRM protect data for businesses in Indonesia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM utilises robust encryption and security measures to ensure the safety of your data. It also helps businesses comply with local data protection laws, ensuring the security and privacy of your client information.",
                },
              },
              {
                "@type": "Question",
                name: "What are the most popular CRM solutions in Indonesia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "While several global CRM platforms are available, Pepper Cloud CRM is quickly gaining traction in Indonesia due to its WhatsApp integration, AI-powered features, and responsive local support.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM an affordable option for Indonesian SMES?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, Pepper Cloud CRM offers flexible pricing that suits businesses at every stage, ensuring that small and medium-sized enterprises can access the features they need without exceeding their budgets.",
                },
              },
              {
                "@type": "Question",
                name: "What qualities should the best CRM for small businesses in Indonesia have?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "The ideal CRM should be user-friendly, affordable, and tailored for the Indonesian market. Pepper Cloud CRM provides these qualities, offering easy navigation, automation, and essential communication tools to improve sales and customer loyalty.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Best CRM in{" "}
              <img className="countryLogo" src={indonesia} alt="Indonesia" />{" "}
              <span className="countryHighlight">Indonesia</span> to automate
              and scale your sales
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Unlock your sales team's potential with the best CRM software in
              Indonesia. Pepper Cloud CRM simplifies lead tracking, automates
              workflows, and strengthens customer engagement.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-powered sales automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Unified customer communication
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Integrated WhatsApp CRM
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              The ultimate CRM guide for Indonesian businesses
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the top CRM choice for businesses in Indonesia
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Close more deals, faster, with CRM in Indonesia
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM tool for your growing business in
                Indonesia
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  "Benefits of using a CRM tool for your growing business in Indonesia"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Real-world CRM applications across Indonesia industries
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                Real estate
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Training & coaching
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Financial services
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              Scale smarter with the best 5 CRM platforms in Indonesia
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TruestedSection />
      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQS – Choosing CRM software in Indonesia"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Close every deal efficiently with Indonesia's smartest sales CRM
              tool.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Indonesia;
